import React from "react";
import { useTranslation } from "react-i18next";

export default function LanguageSwitcher() {
  const { i18n, t } = useTranslation();

  const handleChange = (e) => {
    const lang = e.target.value;
    i18n.changeLanguage(lang);
    try {
      localStorage.setItem("lang", lang);
    } catch {}
  };

  return (
    <div className="absolute right-6 top-4 z-20">
      <label className="mr-2 text-xs text-gray-400 uppercase tracking-wide">
        {t("language.label")}
      </label>
      <select
        value={i18n.language || "ro"}
        onChange={handleChange}
        className="bg-[#1f1f1f] border border-gray-700 text-gray-200 px-3 py-1.5 rounded-md text-xs focus:outline-none focus:ring-1 focus:ring-purple-500"
      >
        <option value="ro">RO</option>
        <option value="en">EN</option>
      </select>
    </div>
  );
}
